<template>
  <v-dialog v-model="dialog" persistent scrollable width="500px">
    <template #activator="{ on }">
      <app-button outlined v-on="on">Clear all</app-button>
    </template>
    <v-card flat>
      <v-card-title>
        <h6 class="title ml-2 pt-2">Clear Trial Notifications</h6>
      </v-card-title>
      <v-card-text class="scrolling-modal-center pl-4 pr-4 pb-4 pt-0">
        <p>
          Removing internal notifications cannot be undone. All existing notifications will be
          removed and cannot be restored. Are you sure that you want to clear your existing VIPER
          notifications?
        </p>
        <v-checkbox
          v-model="form.allTrials"
          label="All Trials"
          :disabled="!!form.trialId"
          @change="onAllTrialsChange"
        />
        <v-autocomplete
          ref="trialIdInput"
          v-model="form.trialId"
          label="Trial"
          outlined
          clearable
          :disabled="!!form.allTrials"
          :items="trials"
          :error-messages="errorMessages"
          @change="onTrialIdChange"
        />
      </v-card-text>
      <v-divider />
      <v-card-actions class="pa-3">
        <v-spacer />
        <app-button-cancel @click="cancel()" />
        <app-button :disabled="disableSave" :loading="loading" @click="submit">Confirm</app-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { trialsService } from '@/services/trials-service'
import { MyActiveOrganization, MyUser } from '@/helpers/my-account-helper'
import { mapActions } from 'vuex'
import { validationMixin } from 'vuelidate'
import { requiredIf } from 'vuelidate/lib/validators'
import _ from 'lodash'

export default {
  mixins: [validationMixin],
  data() {
    return {
      dialog: false,
      loading: false,
      trials: [],
      form: {
        allTrials: false,
        trialId: null
      }
    }
  },
  computed: {
    disableSave() {
      return this.loading || (!this.form.allTrials && !!!this.form.trialId)
    },
    errorMessages() {
      const errors = []
      if (!this.$v.form.trialId.$dirty) {
        return errors
      }
      !this.$v.form.trialId.required && errors.push('Field is required')
      return errors
    }
  },
  async created() {
    const response = await trialsService.getTrials(MyActiveOrganization.id)
    this.setTrialOptions(response.data)
  },
  methods: {
    ...mapActions(['CLEAR_USER_NOTIFICATIONS']),
    setTrialOptions(trials) {
      this.trials = _.map(trials, it => {
        return {
          text: it.externalId || it.trial.id,
          value: it.trial.id
        }
      })
    },
    onTrialIdChange() {
      if (this.form.trialId) {
        this.form.allTrials = false
      }
      this.$v.form.trialId.$touch()
    },
    onAllTrialsChange() {
      if (this.form.allTrials) {
        this.form.trialId = null
      }
      this.$v.form.trialId.$touch()
    },
    cancel() {
      this.form = {}
      this.$refs.trialIdInput.reset()
      this.dialog = false
    },
    async submit() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.loading = true
        await this.CLEAR_USER_NOTIFICATIONS({
          orgId: MyActiveOrganization.id,
          params: this.form
        })
        this.loading = false
        this.cancel()
      }
    }
  },
  validations: {
    form: {
      trialId: {
        required: requiredIf(function() {
          return !this.form.allTrials
        })
      }
    }
  }
}
</script>
